import { motion } from "framer-motion";

const TermsPage = () => {
  return (
    <div>
      <section className="bg-warm-800 text-white py-14 md:py-20">
        <div className="max-w-7xl mx-auto px-6">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <h1 className="text-4xl sm:text-5xl font-medium tracking-tight mb-4"
              style={{ fontFamily: 'Cormorant Garamond, Georgia, serif' }}>
              Terms of Service
            </h1>
            <p className="text-warm-200">Last updated: February 2026</p>
          </motion.div>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-3xl mx-auto px-6">
          <div className="space-y-8 text-sm text-gray-700 leading-relaxed">
            <div>
              <h2 className="text-xl font-semibold text-gray-900 mb-3" style={{ fontFamily: 'Cormorant Garamond, Georgia, serif' }}>1. Acceptance</h2>
              <p>By using this website and our services, you agree to these Terms of Service. If you do not agree, do not use the website or services.</p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-gray-900 mb-3" style={{ fontFamily: 'Cormorant Garamond, Georgia, serif' }}>2. Services</h2>
              <p>The Pillar Project Corporation provides crisis intervention, survivor advocacy, education programs, and resource coordination for survivors of violence. Our services are free and confidential.</p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-gray-900 mb-3" style={{ fontFamily: 'Cormorant Garamond, Georgia, serif' }}>3. Partner Portal</h2>
              <p>Access to the Partner Portal is restricted to authorized agency partners (police departments, caseworkers, attorneys, and approved organizations). Partners agree to:</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Use the portal solely for its intended purpose of submitting referrals and LAP reports</li>
                <li>Maintain the confidentiality of all client information accessed through the portal</li>
                <li>Enable and maintain multi-factor authentication on their accounts</li>
                <li>Report any suspected unauthorized access immediately</li>
                <li>Not share login credentials with unauthorized individuals</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-gray-900 mb-3" style={{ fontFamily: 'Cormorant Garamond, Georgia, serif' }}>4. Data Consent</h2>
              <p>By submitting information through our forms, referral system, or partner portal, you consent to:</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>The collection and encrypted storage of submitted information</li>
                <li>Use of the information for service delivery and case management</li>
                <li>Generation of anonymized, aggregate data for grant reporting</li>
                <li>Retention per our data retention policy (active 0 to 2 years, archived 2 to 7 years, deleted after 7 years)</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-gray-900 mb-3" style={{ fontFamily: 'Cormorant Garamond, Georgia, serif' }}>5. Prohibited Use</h2>
              <p>You may not:</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Use this website to locate, stalk, harass, or harm any individual</li>
                <li>Submit false or misleading information</li>
                <li>Attempt to access restricted areas without authorization</li>
                <li>Scrape, copy, or redistribute content without permission</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-gray-900 mb-3" style={{ fontFamily: 'Cormorant Garamond, Georgia, serif' }}>6. Limitation of Liability</h2>
              <p>The Pillar Project Corporation provides advocacy and resource coordination services. We are not a law firm, medical provider, or emergency service. In case of immediate danger, call 911. For crisis support, call the National DV Hotline at 1-800-799-7233.</p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-gray-900 mb-3" style={{ fontFamily: 'Cormorant Garamond, Georgia, serif' }}>7. Contact</h2>
              <p>The Pillar Project Corporation<br />Baltimore, Maryland<br />(347) 221-4189<br />director@thepillarprojectbaltimore.org</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
